export default __webpack_public_path__ + "static/media/PahnkeMovieNight-screenshot-mobile.e5ad9396.png";